import { hasOrthopulse } from '@odo/shared-ui/clinical/orthopulse';

// The Monday column is "Yes" / "No" / "N/A" or null; doctors want a bare "Yes"/"No".
const ORTHOPULSE_YES = 'Yes' as const;
const ORTHOPULSE_NO = 'No' as const;

/** Normalize the raw Monday value to a strict "Yes" / "No" display label. */
export function formatOrthopulseDisplay(
    orthopulseStatus: string | null | undefined
): typeof ORTHOPULSE_YES | typeof ORTHOPULSE_NO {
    return hasOrthopulse(orthopulseStatus) ? ORTHOPULSE_YES : ORTHOPULSE_NO;
}
